export class UrlConstants {
  constructor() { }
  static URLS = {
    DEV_URL: 'https://mcapi-qa.kaakateeya.com',
  };
  static ENDPOINTS = {
 stage_URL:
      'http://ec2-35-154-46-177.ap-south-1.compute.amazonaws.com/swagger',
    // ADMIN_URL: 'https://webeapi-qa.kaakateeya.com', //qa//uat
    ADMIN_URL: 'https://webeapi-qa.kaakateeya.com',
    //ADMIN_URL: 'http://localhost:55153',
    // ADMIN_URL: 'https://employeeapi.kaakateeya.com',

    // DEV_URL: 'https://webcapi-qa.kaakateeya.com',
    DEV_URL: 'https://websiteapi.kaakateeya.com',
    // Employee
    LOGIN_ADMIN: '/api/Login/LoginEmployeeAsync',
    ADMIN_MASTER: '/api/MaintanceWork/GetProfileBindingsAsync',
    SUBMIT_ASSIGN: '/api/MaintanceWork/GetAssignProfileSettingsAsync',
    SUBMIT_UNASSIGN: '/api/MaintanceWork/ReAssignExpiredMarketingTicketsAsync',
    REASSIGN_TICKET: '/api/MaintanceWork/ReAssignTicketToEmployeeAsync',
    ASSIGN_OWNER: '/api/MaintanceWork/AssignProfileOwnerAsync',
    TICKET_AUTO_ASSIGN: '/api/MaintanceWork/InsertInternalMessageAsync',
    GET_MEMBERSHIP_OFFER: '/api/Registration/GetMemberShipOffersAsync',
    SET_MEMBERSHIP: '/api/Registration/SaveMembershipOfferAsync',

    GENERATE_HOROSCOPE: '/api/Astro/GenerateHoroscopeAsync',
    SAVE_ASTRO_DETAILS: '/api/Astro/SaveUserAstroDetailsAsync',
    // GET_USER_ASTRO_DETAILS: '/api/Astro/GetAstroDetailsAsync',
    GET_INBOX_PROFILE_ASYNC: '/api/Inbox/GetInboxProfilesAsync',

    DASHBOARD_PROFILE: '/api/Dashboard/GetDashboardProfilesAsync',
    SET_USER_SHORTLISTED: '/api/Dashboard/SetAsUserShortListedProfileAsync',
    USER_SEND_INTREST: '/api/Dashboard/SendInterestProfileAsync',
    SEND_MESSAGE_TO_USER: '/api/Dashboard/SendMessageToUserAsync',
    COMMON_ACRIONS: '/api/Dashboard/CommonActionsAsync',
    GET_USER_RM: '/api/Dashboard/GetUserRelationshipManagerDetailsAsync',
    DISPLAY_HELP_CONTACT: '/api/Dashboard/GetContactDetailsAsync',
    REQUEST_USER_PHOTO: '/api/Dashboard/RequestUserPhotoAsync',
    EXPRESS_INTRESET_SKIP_PROCEED:
      '/api/Dashboard/ExpressInterestSkipProceedAsync',
    GET_USER_PROFILE_DETAILS: '/api/OtherProfile/UserOtherProfileDetails',
    GET_USER_PROFILE: '/api/Profile/UserProfileDetailsAsync',
    GET_USER_TYPE: '/api/Dashboard/GetUserAccountTypeAsync',
    GET_INBOX_PROFILES: '/api/Inbox/GetInboxProfilesAsync',
    GET_MESSAGE_PROFILE: '/api/Inbox/GetMessageProfilesAsync',
    GET_USER_MESSAGE_HISTORY: '/api/Inbox/GetUserMessageHistoryAsync',
    GET_INBOX_COUNT: '/api/Inbox/GetInboxCountAsync',
    GET_USER_NOTIFICATION: '/api/Inbox/GetUserNotificationsAsync',

    USER_LOGIN: '/api/Login/LoginUserAsync',
    REFRESH_ACCESS_TOKEN: '/api/Login/RefreshTokenAsync',
    FORGOT_PASSWORD: '/api/Login/ForgotPasswordEmployeeAsync',
    NEW_PASSWORD_SAVE: '/api/Login/SaveForgotPasswordEmployeeAsync',
    USER_LOGOUT: '/api/Login/LogOutAsync',

    UPLOAD_PHOTO: '/api/ManagePhoto/UploadUserPhotoAsync',
    GET_USERPHOTO: '/api/ManagePhoto/UserPhotosAsync',
    SET_PASSWORD_IMAGE:'/api/ManagePhoto/SetAsPasswordProtectedPhotoAsync',

    OTHER_PROFILE_PHOTO: '/api/ManagePhoto/OtherUserPhotosAsync',
    OTHER_PROFILE_PHOTO_SEARCH: '/api/ManagePhoto/UserPhotosAsync',
    DELETE_PHOTO: '/api/ManagePhoto/DeleteUserPhotoAsync',
    SET_USER_PHOTO: '/api/ManagePhoto/SetAsProfilePhotoAsync',

    GET_USER_DETAILS: '/api/OtherProfile/UserOtherProfileDetails',
    UNPAIN_SERVICE_STATUS: '/api/OtherProfile/UnpaidServiceStatusAsync',
    INSERT_EXPRESSVIEW_TICKET: '/api/OtherProfile/InsertExpressViewTicketAsync',

    SAVE_OTHER_DETAILS: '/api/Profile/SaveUserOtherDetailsAsync',
    SAVE_EDUCATION_DETAILS: '/api/Profile/SaveEducationProfessionAsync',
    SAVE_FAMILY_DETAILS: '/api/Profile/SaveUserFamilyDetailsAsync',

    GET_MASTER_DATA: '/api/MasterData/MasterDataAsync',
    GET_COUNTRY_CODE: '/api/MasterData/CountryCodeDataAsync',

    CHECK_EMAIL_MOBILE_EXIST: '/api/Registration/CheckEmailMobileExistAsync',
    REGISTER_USER: '/api/Registration/RegisterUserAsync',

    SUCCESS_STORY: '/api/Home/GetRandomSuccessStoriesAsync',

    VERIFY_MOBILE_OTP: '/api/Verification/VerifyMobileNumberAsync',
    RESEND_MOBILE_OTP: '/api/Login/ResendVerficationCodeAsync',
    EDIT_MOBILE: '/api/Verification/EditMobileNumberAsync',

    EDIT_EMAIL: '/api/Verification/EditEmailAsync',
    RESEND_EMAIL_VERIFICATION: '/api/Verification/ResendEmailVerficationAsync',
    VERIFY_EMAIL: '/api/Verification/VerifyEmailAsync',

    CHECK_REGISTRATION_STEP: '/api/Login/GetUserCurrentFormStatusAsync',

    UPLOAD_PROFILE_PHOTO: '/api/ManagePhoto/UploadUserPhotoAsync',
    UPLOAD_EMPLOYEE_PHOTO:'/api/ManagePhoto/UploadEmployeePhotoAsync',

    // Inbox
    COMMON_ACTION_ON_PROFILE_VIEW: '/api/Dashboard/CommonActionsAsync',

    SIDE_MESSAGE: '/api/Inbox/GetMessageProfilesAsync',
    GET_SUMMERY_CARD: '/api/Dashboard/GetDashboardSummaryDataAsync',
    GET_USER_PHOTOS: '/api/ManagePhoto/UserPhotosAsync',

    SET_USER_PROFILE_PIC: '/api/ManagePhoto/SetAsProfilePhotoAsync',
    DELETE_PROFILE_PIC: '/api/ManagePhoto/DeleteUserPhotoAsync',

    GET_USER_BASIC_DETAILS: '/api/Profile/UserBasicDetailsAsync',
    GET_USER_FAMILY_DETAILS: '/api/Profile/UserFamilyDetailsAsync',
    GET_USER_PROFESSION_DETAILS: '/api/Profile/UserProfessionDetailsAsync',
    GET_USER_EDUCATION_DETAILS: '/api/Profile/UserEducationDetailsAsync',
    GET_USER_LOCATION_DETAILS: '/api/Profile/UserLocationDetailsAsync',
    GET_USER_CONTACT_DETAILS: '/api/Profile/UserContactDetailsAsync',
    GET_USER_PARTNER_PRE_DETAILS:
      '​/api​/Profile​/PartnerPreferenceDetailsAsync',
    GET_PARTNER_PREFERENCE_COUNT: '/api/PartnerPreference/GetPartnerPreferencesCountAsync',
    GET_USER_PROPERTY_DETAILS: '/api/Profile/UserPropertyDetailsAsync',
    CHANGE_USER_PASSWORD: '/api/Profile/SaveChangePasswordUserAsync',
    CHANGE_USER_PROFILE_ACCOUNT:
      '/api/Verification/SendEmailMobileVerficationCodeAsync',

    CHANGE_PRIMARY_CONTACT:
      '/api/Verification/SendEmailMobileVerficationCodeAsync',
    VERIFY_CHANGE_CONTACT: '/api/Verification/UpdateVerifyEmailMobileAsync',

    ASTRO_DETAILS_GET: '/api/Astro/GetAstroDetailsAsync',
    SAVE_USER_ASTRO_DETAILS: '/api/Astro/SaveUserAstroDetailsAsync',
    GENERATE_USER_HOROSCOPE: '/api/Astro/GenerateHoroscopeAsync',
    UPLOAD_USER_HOROSCOPE: '/api/Astro/UploadHoroscopeImageAsync',

    GET_USER_PARTNER_PREFERENCE: '/api/Profile/PartnerPreferenceDetailsAsync',
    SAVE_USER_PARTNER_PREFERENCE:
      '/api/Profile/SaveUserPartnerPreferencesAsync',

    GET_USER_PROFILE_PROFESSION_DETAILS:
      '/api/Profile/UserEducationProfessionDetailsAsync',

    GET_USER_PROFILE_FAMILY_DETAILS: '/api/Profile/UserFamilyDetailsAsync',
    SAVE_FAMILY_PROFILE_DETAILS: '/api/Profile/SaveUserFamilyDetailsAsync',

    GET_USER_MEMBERSHIP_DETAILS: '/api/Profile/MembershipOffersAsync',

    // Search
    GET_DEFAULT_SEARCH: '/api/Search/UserDefaultSearchInformationAsync',
    SEARCH_WITH_PARAMETER: '/api/Search/ProfileSearchAsync',
    USER_SAVED_SEARCH: '/api/Search/UserSavedSearchAsync',
    SEARCH_USER_WITH_ARRAY: '/api/Search/SearchAsync',
    SET_SHORTLIST_PROFILE: '/api/SharedMethod/SetAsUserShortListedProfileAsync',
    KEY_WORD_SEARCH: '/api/Search/KeywordSearchAsync',

    // Contact
    GET_USER_CONTACT: '/api/Dashboard/ViewContactAsync',
    EDIT_WITH_SECTION: '/api/Profile/SaveUserEditDetailsAsync',
    GET_PAYMENT: '/api/Payment/GetUserPaymentStatisticsAsync',

    // Home

    CHANGE_USER_TYPE: '/api/Home/ChangeUserServiceType',
    USER_PAYMENT_SEND: '/api/Payment/SaveUserPaymentDetailsAsync',
    REGISTRATION_PROFILE_VALIDATED: '/api/Registration/GetRegistrationValidationAsync',
    REGISTRATION_PROFILE_VALIDATED_COUNT: '/api/Registration/GetRegistrationValidationCountAsync',
    EMP_VIEW_PROFILE: '/api/OtherProfile/GetUserFullDetailsByAdminAsync',
    GUEST_TICKET_CREATE: '/api/MyAccount/InsertTicketInfoAsync',
    TICKET_INFORMATION: '/api/MyAccount/GetMarketingTicketinformationAsync',
    TICKET_EXPRESS_RELATION_INFO: '/api/MyAccount/ExpressInterestLinqAsync',
    TICKET_PROFILE_BINDINGS: '/api/Dependency/GetMyProfileBindingsAsync',
    TICKET_REPLYTYPE_DATA: '/api/MyAccount/MatchFollowUpLinqAsync',
    TICKET_SAVE_INCOMING_CALL: '/api/Dependency/InsertOutIncomingcallAysnc',
    TICKET_SAVE_INTERNAL_MEMO: '/api/Payment/InsertInternalMemoAsync',
    TICKET_CLOSE: '/api/Payment/CloseTicketAsync',
    SEND_VERIFICATION_CODE: '/api/CustomerVerification/ResendVerficationCodeAsync',
    VERIFY_TICKET_OTP: '/api/CustomerVerification/VerifyMobileNumberAsync',
    VERIFY_TICKET_EMAIL: '/api/CustomerVerification/ResendEmailVerficationAsync',
    VERIFY_EMAIL_MANUALLY: '/api/CustomerVerification/UpdateEmailVerificationAsync',
    GET_TICKET_PHOTOS: '/api/Dependency/GetPhotoSlideImages',
    REMAINDER_FORM: '/api/MyAccount/CreateReminderInsertAsync',

    //Payment Details
    GET_PAYMENT_DETAILS: '/api/Payment/GetUserPaymentDetailsAsync',
    SAVE_SA_AMOUNT: '/api/Payment/UpdateSAAmountAsync',
    GET_PROFILE_OFFERS: '/api/Registration/GetMemberShipOffersAsync',
    SAVE_PAYMENT_DETAILS_WITH_OFFERS: '/api/Payment/SaveUserPaymentDetailsByEmployeeAsync',
    GET_POINT_DAYS: '/api/Payment/GetPaymentExentionPointsDaysAsync',

    //Marketing slide show API
    GET_BASIC_MASTER_DATA: '/api/MaintanceWork/GetProfileBindingsAsync',
    MARKETING_VIEW_HISTORY: '/api/MyAccount/MarketingTicketHistoryInfoAsync',
    GET_MASTER_DATA_RESPONSE_TYPE: '/api/MasterData/MasterDataAsync?MasterName=MarketingTicket',
    SEND_SMS_TO_SLIDE_TICKET: '/api/MyAccount/MarketingSendSmsAsync',
    SEND_EMAIL_TO_SLIDE_TICKET: '/api/MyAccount/MarketingMailSendAsync',
    SEND_FULL_PROFILE: '/api/MyAccount/MatchFollowUpResendMailAsync',
    GET_SET_DEL_DETAILS: '/api/MyAccount/ViewAllCustomersSettleDeleteInfoAsync',
    SAVE_SIBLING_DATA: '/api/MyAccount/FeeUpdateAsync',

    MATCH_COUNT: '/api/MyAccount/GetMatchfollowupCountsAsync',


    //Admin Profile Info
    GET_ADMIN_PROFILE_INFO: '/api/PartnerPreference/GetAdminMailPartnerPreferenceDetailsAsync',
    GET_ASSIGNED_DUPLICATE_PROFILE: '/api/MaintanceWork/DuplicateProfilesAsync',
    SAVE_PAYMENT_ADIMIN_FORM: '/api/Payment/EditPaymentDetailsAsync',
    MATCH_RESEND: '/api/MyAccount/GetMatchfollowupPendingRecentAsync',


    //Guest Ticket Creation
    GET_GUEST_TICKET_ASYNC: '/api/MyAccount/GuestTicketCreationAsync',
    GET_TICKET_PROFILE_EXISTS: '/api/MyAccount/ProfileIdExistOrNotAsync',
    INSERT_GUEST_TICKET: '/api/MyAccount/InsertTicketInfoAsync',

    SAVE_USER_PARTNER_PREFERENCE_EMP: '/api/PartnerPreference/UpdateAdminMailPartnerPreferenceAsync',
    GET_PARTNER_SUITABLE_PROFILES: '/api/PartnerPreference/GetAutoMailSuitableProfilesAsync',
    SAVE_AUTO_MAIL_PROFILE_PRIORITY: '/api/PartnerPreference/UserAutoMailProfilePriorityByEmployeeAsync',
    GET_MATCH_FOLLOW_UP: '/api/MyAccount/MatchfollowUpSlideShowResultAsync',
    GET_STAFF_NAMES: '/api/MyAccount/GetMatchfollowupOtherCountsAsync',
    GET_STAFF_DATA: '/api/MyAccount/GetMatchfollowupResultbyOtherStaffAsync',
    GET_MATCH_TICKET_HOSTORY: '/api/MyAccount/GetMatchFollowUpTicketInformationAsync',
    INSERT_MFP_REMAINDER: '/api/SharedMethod/GetReminderCreationAsync',

    // GET_OTHER_MATCH_FOLLOW_UP:''
    SEND_WAKEUP_MESSAGE: '/api/Registration/EmployeeSmsFormatchFollowupAsync',
    SEND_SMS: '/api/MyAccount/MatchFollowupSendSmsAsync',
    GET_BRIDE_GROOM_DATA: '/api/MyAccount/EmployeeNameInfoAsync',
    SAVE_MATCH_MEETING_ENTRY_FORM: '/api/MyAccount/MatchMeetingCreateAsync',
    ACTIVE_PROFILES: '/api/MyAccount/ProfileStatustoActiveAsync',
    GET_MATCH_TICKET_STATUS: '/api/MyAccount/GetmatchfollowupTicketStatusAsync',
    SAVE_MATCH_FOLLOWUP: '/api/ExpressIntrest/UpdateExpressIntrestViewfullprofileAsync',
    INSERT_INCOMING_COMMUNICATION: '/api/MyAccount/InsertoutIncomingCallCommunicationLogAsync',
    SEND_EMAIL_TICKET: '/api/MyAccount/MatchFollowupMailSendAsync',

    SAVE_POINTS_DATA: '/api/Payment/SavePaymentPointsAsync',
    CHECKDOBNAME: '/api/Registration/CheckNameSurNameDOBAsync',
    CUSTOMER_REGISTRATION_ONE: '/api/Registration/RegisterCustomerByEmployeeAsync',
    CUSTOMER_FULL_STEP_REG: '/api/Registration/CustomerDetailsByEmployeeAsync',
    CHECK_EMAIL_MOBILE: '/api/Registration/EmailMobileNumberExistsAsync',

    //Settlement Details
    SA_FORM_VIEW: '/api/SharedMethod/ViewSettlementFormGetAsync',
    SA_FORM_DELETE: '/api/SharedMethod/DeleteSettleFormGetAsync',


    //Edit/View
    SEARCH_EDIT_VIEW: '/api/EditView/SearchViewEditProfileAsync',
    SETTLE_DELETE_INFO_ASYNC: '/api/MyAccount/ViewAllCustomersSettleDeleteInfoAsync',
    MMSERIOUS_ASYNC: '/api/CommonAPI/mmSeriesDataAsync',
    EDIT_VIEW_OWNER_DETAILS: '/api/CommonAPI/SettlementReasonBasedOnEmpAsync',
    PLAY_BUTTON_PROFILE_DETAILS: '/api/EditView/ProfileIDPlayAsync',
    PLAY_SLIDE_SHOW: '/api/EditView/SearchViewEditProfileAsync',
    UPLOAD_SA_PHOTO: '/api/SharedMethod/UploadSettlementFormAsync',
    EDIT_VIEW_PHOTO_REQUEST: '/api/CommonAPI/CustomerPhotoRequestDisplayAsync',
    EDIT_VIEW_FORGOT_PASSWORD: '/api/Dependency/GetForgotPasswordAsync',

    //Express Interest
    GET_SERVICE_PROFILE_INFO: '/api/ExpressIntrest/ServiceInfoAsync',
    SAVE_EXPRESS_INTEREST: '/api/ExpressIntrest/ExpressIntrestAsync',
    GET_EXPRESS_IMAGES: '/api/ExpressIntrest/SendServiceProfileIDsAsync',
    SEND_EDIT_VIEW_FORGOT_PASSWORD: '/api/Dependency/GetForgotPasswordAsync',
    GET_SERVICE_COUNT:'/api/ExpressIntrest/GetExpressInterestPermissionAsync',
    //Communications Log


    // GET_COMMUNICATION_LOG: '/api/Registration/EmployeeCommunicationLogAsync',
    // SEND_EMAIL_COMMUNICATIONLOG: '/api/Registration/CommunicationLogSentPhotosEmailAsync',
    // SEND_RESEND_COMMUNICATIONLOG: '/api/Registration/CommunicationLogRvrAndResendAsync',

    // Service slide show
    GET_SERVICE_SLIDESHOW_DATA: '/api/Registration/ServiceSlideShowBasedOnProfileIDAsync',
    

    // Advanced Search
    PRELOAD_SEARCH: '/api/Search/GetPrimaryCustomerDataAsync',
    ADVANCED_SEARCH: '/api/Search/AdvanceSearchAsync',
    GENERAL_SEARCH: '/api/Search/GeneralSearchAsync',
    PROCEED: '/api/ExpressIntrest/InsertCustomerExpressInterestAsync',

    GET_COMMUNICATION_LOG:'/api/Registration/EmployeeCommunicationLogAsync',
    SEND_EMAIL_COMMUNICATIONLOG:'/api/Registration/CommunicationLogSentPhotosEmailAsync',
    SEND_RESEND_COMMUNICATIONLOG:'/api/Registration/CommunicationLogRvrAndResendAsync',

    //Edit/View Dashboard Services
    GET_EDIT_VIEW_EDUCATIONAL_DETAILS: '/api/Education/CustomerEducationDetailsAsync',
    GET_EDIT_VIEW_PERSONAL_DETAILS:'/api/Profession/PersonalDetailsCustomerAsync',
    GET_EDIT_VIEW_EDUCATION_ABOUT:'/api/Profession/EducationProfessionAboutYourselfAsync',
    GET_EDIT_VIEW_NO_DATA_INFO: '/api/CommonAPI/NoDataInFormationLinkDisplayAsync',
    SEND_UPDATE_EDIT_VIEW_PERSONAL_DETAILS:'/api/Profession/UpdatePersonalDetailsCustomersDetailsAsync',
    SEND_UPDATE_EDIT_VIEW_EDU_DETAILS:'/api/Education/UpdateCustomerEducationDetailsAsync',
    DELETE_EDIT_VIEW_OBJ:'/api/Education/CustomerSectionsDeletionsAsync',
    GET_EDIT_VIEW_PROFESSIONAL_DETAILS:'/api/Profession/CustomerProfessionDetailsAsync',
    SEND_UPDATE_EDIT_VIEW_PROFESSIONAL_DETAILS:'/api/Profession/UpdateCustomerProfessionDetailsAsync',
    GET_EDIT_VIEW_GOALS_INTERESTS_DETAILS:'/api/Profession/EducationProfessionAboutYourselfAsync',
    GET_EDIT_VIEW_DASHBOARD_PROFILE_DETAILS:'/api/CommonAPI/CustomerPersonalOfficePurposeAsync',
    EDIT_VIEW_MERIT_SELECTED:'/api/Profession/CustomerProfileSettingGradeSelectionAsync',

    //Click to call

    GET_CUSTOMER_CONTACT_ID: '/api/CommonAPI/GetCustomerContactIDAsync',
    INITIATE_CLICK_TO_CALL: '/api/ClickToCall/ClickToCallRequestAsync',
    GET_CALL_LOGS: '/api/ClickToCall/ClickToCallLogsAsync',
    GET_EMP_CALL_REPORTS: '/api/ClickToCall/ClickToCallReportsAsync',

    //Bank Details
    SEND_BANK_DETAILS: '/api/EditView/SendBankDetailsSMSAsync',


    //Edit View Parent Details
    GET_EDIT_VIEW_PARENT_DETAILS:'/api/Parents/CustomerParentsDetailsAsync',
    SAVE_EDIT_VIEW_PARENT_DETAILS:'/api/Parents/UpdateCustomerParentsDetailsAsync',
    SAVE_EDIT_VIEW_PARENT_CONTACT_DETAILS:'/api/Parents/UpdateCustomerContactAddressDetailsAsync',
    SAVE_EDIT_VIEW_PARENT_HEALTH_DETAILS:'/api/Parents/UpdateCustomerPhysicalAttributesAsync',
    SAVE_EDIT_VIEW_ABT_FAMILY:'/api/Parents/ParentsAboutMyFamilyAsync',

    //Edit Partner Preferences 
    GET_PARTNER_PREFERENCES:'/api/PartnerPreference/CustomerPartnerPreferenceDetailsAsync',
    SAVE_EDIT_VIEW_PARTNER_DETAILS:'/api/PartnerPreference/UpdateCustomerPartnerPreferenceDetailsAsync',
    SAVE_CADITATE_DESCRIPTION:'/api/PartnerPreference/PartnerpreferenceInDetailDataAsync',
    SAVE_PARTNER_DESCRIPTION:'/api/PartnerPreference/PartnerDescribeYourSelfAsync',

    //Edit view contact details
    SAVE_EDIT_VIEW_CONTACT_DETAILS:'/api/Contacts/UpdateCustomerContactsDetailsAsync',
    SAVE_RELATION_NAME_DETAILS:'/api/Contacts/CustomerContactsDetailsAsync',
    SAVE_REFERENCE_DETAILS:'/api/Contacts/UpdateContactDetailsReferenceAsync',


    //Payment Authorization
    GET_PAYMENT_AUTH_DATA:'/api/Payment/CustomerUnAuthorizedPaymentsAsync',
    SAVE_PAYMENT_AUTHORIZATION:'/api/Payment/SetPaymentAuthorizationAsync',
    SAVE_TICKET:'/api/Payment/CheckMarketingTicketAsync',
    SAVE_EDIT_GET_AESTRO:'/api/Astro/GetAstroDetailsAsync',

    //Property Details
    SAVE_EDIT_GET_PROPERTY:'/api/Property/CustomerPropertyDetailsAsync',
    SAVE_PROPERTY_DETAILS:'/api/Property/UpdateCustomerPropertyDetailsAsync',

    //Relative Details
    SAVE_EDIT_GET_RELATIVE_DETAILS: '/api/Relative/CustomerRelativesDetailsAsync',
    UPDATE_FATHER_BROTHER_PROPERTY:'/api/Relative/UpdateFatherBrotherAsync',
    UPDATE_FATHER_SISTER_PROPERTY:'/api/Relative/UpdateFatherSisterAsync',
    UPDATE_MOTHER_BROTHER_PROPERTY:'/api/Relative/UpdateMotherBrotherAsync',
    UPDATE_MOTHER_SISTER_PROPERTY:'/api/Relative/UpdateMotherSisterAsync',
    DELETE_EDIT_VIEW_RELATIVE_OBJ:'/api/Education/CustomerSectionsDeletionsAsync',

    //Refrences
    SAVE_EDIT_GET_REFERENCE_DETAILS:'/api/Reference/CustomerReferenceDetailsAsync',
    UPDATE_REFERENCE_DETAILS:'/api/Reference/UpdateCustomerReferenceDetailsAsync',

    //Office purpose
    EDIT_VIEW_DONT_SHOW_PROFILE:'/api/CommonAPI/DontShowServiceAsync',
    EDIT_VIEW_OFFICE_ABOUT_PROFILE:'/api/CommonAPI/AboutProfileAsync',
    EDIT_VIEW_OFFICE_ATTEND_CUSTOMER:'/api/CommonAPI/SaveCustomerAttendDetailsAsync',
    EDIT_VIEW_OFFICE_SHOW_ATTENDED_CUSTOMERS: '/api/CommonAPI/GetCustomerAttendDetailsAsync/{custID}',


    //Match meeting
    MATCH_MEETING_BRIDE_GROOM_ASYNC:'/api/MyAccount/MatchMeetingDataAsync',

    //Profile Settings
    EDIT_PROFILE_SETTING_DETAILS:'/api/ProfileSettings/CustomerProfileSettingsDetailsAsync',
    SAVE_PROFILE_SETTINGS_OBJECT:'/api/ProfileSettings/UpdateCustomerProfileSettingDetailsAsync',
    SAVE_TEMP_PROFILE_SETTINGS_OBJECT:'/api/ProfileSettings/UpdateCustomerTempDeleteSettingsAsync',
    SAVE_PROFILE_GRADES:'/api/Profession/CustomerProfileSettingGradeSelectionAsync',
    SAVE_CUSTOMER_LOGIN:'/api/ProfileSettings/UpdateEmplogintoCustomerSiteAsync',
    SEARCH_PERSONAL_OFFICE:'/api/CommonAPI/CustomerPersonalOfficePurposeAsync',
    SEARCH_GET_PRIMARY_CUSTOMER:'/api/ViewFullProfile/GetSearchPersonalVisitAsync',
    DELETE_HORO_IMG:'/api/Astro/DeleteUserHoroscopeAsync',

     // Sibling
 
     GET_SIBLING_DETAILS: '/api/Siblings/CustomerSiblingsDetailsAsync',
     UPDATE_SIBLING_COUNT: '/api/Siblings/UpdateSiblingCountsAsync',
     UPDATE_SIBLING_BROTHER: '/api/Siblings/UpdateCustomerSiblingsDetailsBrotherAsync',
     UPDATE_SIBLING_SISTER: '/api/Siblings/UpdateCustomerSiblingsDetailsSisterAsync',
  
     // Spouse
     GET_SPOUSE_DETAILS: '/api/Spouse/CustomerSpouseDetailsAsync',
     UPDATE_SPOUSE_DETAILS: '/api/Spouse/UpdateCustomerSpouseDetailsAsync',
     ADD_CHILDREN_DETAILS: '/api/Spouse/UpdateSpouseChildDetailsAsync',
  
     //Contact
     CONTACT_GET: '/api/Contacts/CustomerContactsDetailsAsync',
     EDIT_SAVE_PHOTO_REQ:'/api/CommonAPI/CustomerPhotoRequestDisplayAsync',

     //IP ADDRESS
     GETIPADDRESS: '/api/CommonAPI/GetIpAddessAsync',

     //Master page
     ADD_TO_MASTER_DATA: '/api/MaintanceWork/EducationProfessionMasterdataInsertUpdateAsync',

     //Profile Validation Slide Show
     PLAY_SLIDE_SHOW_PROFILE_VALIDATION:'/api/Registration/RegistrationValidationSlideAsync',
     PERSONAL_DATA_ASYNC:'/api/MyAccount/GetPersonalinteractionMatchFollowupAsync',
     OPEN_MATCH_FOLLOW_TKT_ASYNC:'/api/MyAccount/OpenMatchfollowupTicketAsync',
     TICKET_CREATION_MATCH_FOLLOWUP:'/api/SharedMethod/MatchFollowUpTicketCreationAsync',
     EMP_VIEW_MATCHFOLLOWUP_PROFILE:'/api/ViewFullProfile/CustomerProfileDetailsAsync',

     SERVICE_SLIDE_SHOW_ASYNC: '/api/MyAccount/PastDaysServiceSlideShowAsync',


    VIEW_CONTACT_EMAIL_OTHER_EMPLOYEES : '/api/CommonAPI/ContactViewHistoryAsync',
    CHECK_OTHER_CONTACT_ACCESS: '/api/CommonAPI/GetContactViewAccessAsync',
    PERMISSION_PAGE_ASYNC: '/api/CommonAPI/GetEmployeePermissionsAsync',
    EMPLOYEE_DETAILS_PAGE_ASYNC:'/api/MaintanceWork/GetEmployeeListAsync',
    EMPLOYEE_CREATE: '/api/MaintanceWork/SaveEmployeeDetailsAsync',
    CREATE_EMP_ID:'/api/MaintanceWork/CreateEmpUserIDAnsync',
    UPDATE_PERMISSION_PAGE_ASYNC: '/api/CommonAPI/UpdateEmployeePermissionsAsync',
    GET_USER_BRANCH_DETAILS: '/api/SharedMethod/GetUserIPAddressAsync',
    UPDATE_USER_BRANCH_IP: '/api/SharedMethod/UpdateUserIPAddressAsync',
    GET_BRANCH_IP_DETAILS: '/api/SharedMethod/MacIPDataAsync',
    UPDATE_BRANCH_IP: '/api/SharedMethod/UpdateMacIPDataAsync',
    REGISTER_BROKER_ASYNC: '/api/SharedMethod/RegisterBrokerAsync',
    GET_BROKER_COMMISSION_ASYNC: '/api/SharedMethod/GetBrokerCommissionsAsync',
    GET_ALL_BROKER_DETAILS: '/api/SharedMethod/GetAllBrokersAsync',
    UPDATE_BROKER_DETAILS: '/api/SharedMethod/UpdateBrokerInfoAsync',
    DELETE_BROKER_DETAILS: '/api/SharedMethod/DeleteBrokerInfoAsync',
    AVAILABLE_CUSTOMERS_INDIA: '/api/CommonAPI/GetAvailableCustomersInIndia',
    GET_CUSTOMERS_LEFT_PAST_WEEK: '/api/CommonAPI/GetCustomersLeftInPastWeek',
    UPDATE_DEPARTED_CUSTOMER_INFO: '/api/CommonAPI/UpdateDepartedCustomerInfo',
    UPDATE_BROKER_PHOTO_OR_FILE: '/api/SharedMethod/UploadBrokerFileAsync',
    DELETE_BROKER_PHOTO_OR_FILE: '/api/SharedMethod/DeleteUserPhotoAsync',
    MY_ACCOUNT_API: '/api/MyAccount/MyProfileAllSlidesDataAsync',
    GET_MASTER_SEARCH_DATA_ASYNC: '/api/MasterData/SearchMasterDataAsync',
    UPDATE_EMP_VIEW_FORMAT: '/api/OtherProfile/UpdateEmployeeViewFormatAsync',
    GET_USER_DETAILS_BY_FORMAT: '/api/OtherProfile/GetUserFullDetailsByFormatAsync',
    GET_EMPLOYEE_PROFILES: '/api/CommonAPI/GetDashboardProfilesAsync',
    GET_ACTIVITY_TRACKING: '/api/CommonAPI/ActivityTrackingAsync',
    GET_EMPLOYEE_ACCESS: '/api/CommonAPI/EmployeePermissionsByCategoryAsync',
    GET_EMPLOYEE_NOTIFICATIONS: '/api/CommonAPI/GetEmployeeNotificationsAsync',

    // R E P O R T S

    GET_UTM_REPORTS: '/api/Report/EmployeeUTMReportsAsync',
    GET_FAILEDREG_REPORTS: '/api/MaintanceWork/GetFailedRegistrationReportDetailsAsync',
    GET_EMP_REPORT_DATA: '/api/Report/EmployeeReportDataAsync',
    GET_EMP_DETAILS_COUNT: '/api/Report/EmployeeActivityReportDataAsync',
    GET_ACTIVITY_POINTS: '/api/Report/GetEmployeeActivityPointsAsync',
    UPDATE_ACTIVITY_POINTS: '/api/Report/UpdateEmployeeActivityPointsAsync',
    GET_TEMP_DELETE_REPORT: '/api/Report/TempDeleteReportDataAsync',
    GET_EMAIL_BOUNCED_REPORT: '/api/Report/EmailBounceReportDataAsync'
  };
}
